import React, { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useAppContext } from "../../context";
import {
    useGetRatesQuery,
    useLazyGetRatesByProductQuery,
} from "../../store/api/conversionApi";
import { currencySellRateData, currencyBuyRateData, getRatesData } from "../../Functions";
import text from "../../Text/text.json"

export default function TabsComponent({ isMobile }: { isMobile: boolean }) {
    const {
        tab,
        setTab,
        setOnlineCourse,
        setIsCash,
        setSellAmount,
        setBuyAmount,
        setSellCurrencyInfo,
        setBuyCurrencyInfo,
        setShowDropdown,
        setCurrentRateData,
        setCurrencyBuyRates,
        setCurrencySellRates,
        setCurrence,
        setCurrencyData,
        setOfficialCourse,
        setTableTitle,
        setCity,
        setProduct,
        setSelectDisabled,
        product,
        city,
        showOnlineTab
    } = useAppContext();

    // 🟣 ონლაინ კურსები
    const onlineRates = useGetRatesQuery(undefined, {
        skip: tab !== 2,
        pollingInterval: 60000,
    });

    const [triggerRates, cashlessRates] = useLazyGetRatesByProductQuery();
    useEffect(() => {
        if (tab === 2) return;

        triggerRates({
            isCash: tab === 0,
        });
    }, [tab, triggerRates]);


    useEffect(() => {
        if (tab === 2) return;
        if (!product && !city) return;

        triggerRates({
            isCash: tab === 0,
            ...(product ? { RateProductID: product } : {}),
            ...(city ? { RateCityID: city } : {}),
        });
    }, [product, city, tab, triggerRates]);

    useEffect(() => {
        const rates = tab === 2 ? onlineRates.data : cashlessRates.data;
        if (!rates) return;

        const hasNbgRate = rates.some((r: any) => Boolean(r?.NBGRate));
        setOfficialCourse(hasNbgRate);

        const data = getRatesData(rates);
        setCurrentRateData(data);
    }, [tab, onlineRates.data, cashlessRates.data, setOfficialCourse, setCurrentRateData]);
    // 🧠 რომელ data-ს ვხმარობთ
    const ratesData =
        tab === 2 ? onlineRates.data : cashlessRates.data;

    const isSuccess =
        tab === 2 ? onlineRates.isSuccess : cashlessRates.isSuccess;


    // 🔁 Context განახლება
    useEffect(() => {
        if (!isSuccess || !ratesData?.length) {
            setCurrencyData(false);
            setCurrentRateData([]);
            return;
        }

        setCurrencyData(true);

        setCurrence(
            Array.from(
                Array.from(
                    new Set(
                        tab !== 2 ?
                            ratesData.flatMap((r: any) => [r.SourceISO, r.TargetISO])
                            :
                            ratesData.flatMap((r: any) => [r.sourceCurrency, r.targetCurrency])
                    )
                ).sort()
            )
        );


        const sellRates: any = currencySellRateData(ratesData, tab);

        const buyRates: any = currencyBuyRateData(ratesData, tab);

        // Ensure sellRates and buyRates are objects, not arrays
        setCurrencySellRates(sellRates);
        setCurrencyBuyRates(buyRates);


        ratesData?.forEach((rate: any) => {

            const hasNbgRate = Boolean(rate?.NBGRate);

            hasNbgRate ? setOfficialCourse(hasNbgRate) : setOfficialCourse(false);

        })

        const data = getRatesData(ratesData);

        setCurrentRateData(data);
    }, [isSuccess, ratesData, setCurrentRateData, setCurrencyBuyRates, setCurrencySellRates, setCurrence, setCurrencyData, setOfficialCourse, tab]);



    const handleTabChange = (_: any, newValue: number) => {
        setSellAmount("");
        setBuyAmount("");
        setSellCurrencyInfo("GEL");
        setBuyCurrencyInfo("USD");

        setTab(newValue);
        setOnlineCourse(newValue === 2);
        setIsCash(newValue === 0);
        setShowDropdown(newValue !== 2);
        setTableTitle("")
        setCity(null)
        setProduct(null)
        setSelectDisabled(true);
    };

    return (
        <Tabs
            value={tab}
            onChange={handleTabChange}
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtons={isMobile ? "auto" : false}
            sx={{
                width: isMobile ? "100%" : "auto",
                "& .MuiTabs-indicator": {
                    backgroundColor: "#ff6a6a",
                    height: "3px",
                    borderRadius: "2px",
                },
                "& .MuiTab-root": {
                    fontSize: "15px",
                    fontWeight: 500,
                    textTransform: "none",
                    minWidth: 120,
                },
                "& .Mui-selected": {
                    color: "#ff6a6a !important",
                },
            }}
        >
            <Tab className="font-helviteca text-blue-80" label={text.tabNames.cash} />
            <Tab className="font-helviteca text-blue-80" label={text.tabNames.nonCash} />
            {showOnlineTab && <Tab className="font-helviteca text-blue-80" label={text.tabNames.online} />}
        </Tabs>
    );
}
